import { render, staticRenderFns } from "./OrderTypeDeliveryFormattedField.vue?vue&type=template&id=5c0681d5&"
import script from "./OrderTypeDeliveryFormattedField.vue?vue&type=script&lang=js&"
export * from "./OrderTypeDeliveryFormattedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0681d5')) {
      api.createRecord('5c0681d5', component.options)
    } else {
      api.reload('5c0681d5', component.options)
    }
    module.hot.accept("./OrderTypeDeliveryFormattedField.vue?vue&type=template&id=5c0681d5&", function () {
      api.rerender('5c0681d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/OrderTypeDeliveryFormattedField.vue"
export default component.exports